export default __webpack_public_path__ + "static/media/walter-bright.6402cb6f.png";